import React from "react";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import reduxThunk from "redux-thunk";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";

import reducers from "./index";

const Root = ({ children, initialState = {} }) => {
	const { databasesRef } = useContext(AuthContext);
	const store = createStore(reducers, { ...initialState, auth: { databasesRef } }, applyMiddleware(reduxThunk));

	return <Provider store={store}>{children}</Provider>;
};

export default Root;
